module.exports = __webpack_public_path__ + "img/Imagem_7.af93f19f.png";